module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 85.9299e6dd.png";